import { initials } from "@/lib/kpi";

export default function Avatar({ name, size = 38, color = "#c0392b" }) {
  return (
    <div
      className="avatar notranslate"
      translate="no"
      style={{
        width: size,
        height: size,
        background: color,
        fontSize: Math.round(size * 0.33),
      }}
      aria-hidden="true"
    >
      {initials(name)}
    </div>
  );
}
